import Signup from "../../components/signup/signup.component"

const SignupPage = () => {
    return (
        <div>
            <Signup />
        </div>
    )
}

export default SignupPage;